import { render, staticRenderFns } from "./calculo.ped.itemrow.vue?vue&type=template&id=c95b4e20&"
import script from "./calculo.ped.itemrow.vue?vue&type=script&lang=js&"
export * from "./calculo.ped.itemrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports